import { useWhiteLabelContext } from 'components/white-label';
import { IThemeProperties } from 'lib/types/themes';
import Head from 'next/head';
import { ReactNode } from 'react';
import { ThemeContext } from './context';
import { getThemeCss } from './helpers';

interface IThemeProviderProps {
  children: ReactNode;
  properties?: IThemeProperties;
}

/**
 * Injects the provided theme properties into the DOM and provides the theme
 * properties to its children.
 *
 * Default values are NOT provided for all properties that are not explicitly
 * set.
 */
export const ThemeProvider = ({
  children,
  properties: passedProperties,
}: IThemeProviderProps) => {
  const { organizationTheme } = useWhiteLabelContext();
  const properties = passedProperties || organizationTheme;
  return (
    <ThemeContext.Provider value={{ properties }}>
      <Head>
        <style>{getThemeCss(properties)}</style>
      </Head>
      {children}
    </ThemeContext.Provider>
  );
};
